import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import exclusive from './exclusive/index'
import paradise from './paradise/index'
import myhome from './myHome/index'
import mapActivity from './mapActivity/index'
import cityMap from './cityMap/index'
import identity from './identity/index'
import applyId from './applyId/index'
import blindBox from './blindBox/index'
import anti from "./anti/index"
import metaIdCard from "./metaIdCard/index"
import advertisingPopup from './advertisingPopup/index'
import myVideo from "./myVideo/index"
import metaTerm from './metaTerm/index'
import resultPage from './resultPage/index'
const routes: Array<RouteRecordRaw> = [
  ...exclusive,
  ...paradise,
  ...myhome,
  ...mapActivity,
  ...cityMap,
  ...advertisingPopup,
  ...identity,
  ...applyId,
  ...blindBox,
  ...anti,
  ...metaIdCard,
  ...myVideo,
  ...metaTerm,
  ...resultPage,
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    redirect: '/blindBox'
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
